module.exports = __webpack_public_path__ + "static/img/title1.46fc932.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/universityHall/images/title1.png
// module id = ylvy
// module chunks = 0